import { CircularProgress, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { ERoutes } from '../../../enums';
import { useGameStore } from '../../../stores';
import { Theme, useTheme } from '@mui/material/styles';
import { getTrainingModeData } from '../../../queries';
import { ButtonWithShadow } from '../../Buttons/ButtonWithShadow';
import { useTranslation } from 'react-i18next';

export const TrainingNavBtn: React.FC = () => {
  const { isTrainingPlayedFirstTime, setIsTrainingPlayedFirstTime } =
    useGameStore();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const attempts = useGameStore((state) => state.trainingModeStatus?.attempts);

  const theme = useTheme();
  const startGameHandler = useCallback(async () => {
    setIsLoading(true);
    try {
      await getTrainingModeData();
      setIsLoading(false);
      navigate(ERoutes.trainingMode);
    } catch (error) {
      console.error('Error while [startGameHandler]', error);
    }
  }, [navigate]);

  const playBtnClickHandler = useCallback(() => {
    if (isTrainingPlayedFirstTime) {
      setIsTrainingPlayedFirstTime(false);
      navigate(ERoutes.trainingRules);
      return;
    }
    startGameHandler();
  }, [
    isTrainingPlayedFirstTime,
    navigate,
    setIsTrainingPlayedFirstTime,
    startGameHandler,
  ]);

  return (
    <ButtonWithShadow
      // TODO: commented code is made for unlimited attempts in Training mode. It can be useful in case of new payed features
      // type={isLoading ? 'DISABLED' : 'SUCCESS'}
      type={attempts === 0 || isLoading ? 'DISABLED' : 'SUCCESS'}
      onClick={playBtnClickHandler}
      sx={materialStyles.button(theme)}
      // TODO: remove disabled  in case unlimited mode is necessary
      disabled={attempts === 0 || isLoading}
    >
      {isLoading ? (
        <CircularProgress color="inherit" />
      ) : (
        <Typography sx={materialStyles.playText}>
          {t('game.play_btn')}
        </Typography>
      )}
    </ButtonWithShadow>
  );
};

const materialStyles = {
  button: (theme: Theme) => ({
    width: '131px',
    height: '73px',
    borderRadius: '14px',
    textTransform: 'uppercase',
    mt: '30px',
    [theme.breakpoints.up(960)]: {
      mt: '13px',
      height: '47px',
    },
  }),
  playText: (theme: Theme) => ({
    fontFamily: 'Rubber Duck !important',
    fontSize: '36px',
    [theme.breakpoints.up(960)]: {
      fontSize: '34px',
    },
  }),
};
